import React from 'react';
import { Container, Col, Row, ListGroup, Button, Modal } from 'react-bootstrap';
import { FaTrash, FaPlus } from 'react-icons/fa';

import { IntrashBackend } from './backend';

import 'bootstrap/dist/css/bootstrap.min.css';
import './index.css';


export class BackupsPage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = {
            backups: [],

            backupToDelete: null,

            showDeleteConfirmationModal: false,
            showDeleteConfirmationBackupName: "",

            showErrorModal: false,
            errorModalText: ""
        };
        
        this.refreshData();
    }

    async refreshData() {
        try {
            // Get the backups
            const allBackups = await IntrashBackend.getBackups();

            // Sort them by date
            allBackups.sort((a, b) => { return a.timestamp > b.timestamp ? -1 : 1 });

            // Update the state
            this.setState({ backups: allBackups });
        }
        catch (exc) {
            this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
    }

    async createBackup(e) {
        try {
            await IntrashBackend.createBackup();
            await this.refreshData();
        }
        catch (exc) {
            this.setState({ showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }

    askDeleteBackup(e, backup) {
        this.setState({ backupToDelete: backup, showDeleteConfirmationModal: true, showDeleteConfirmationBackupName: this.timestampToString(backup.timestamp) });
        e.preventDefault();
    }

    async doDeleteBackup(e) {
        try {
            await IntrashBackend.deleteBackup(this.state.backupToDelete.fileName);
            this.setState({ backupToDelete: null, showDeleteConfirmationModal: false, showDeleteConfirmationBackupName: "" });
            this.refreshData();
        }
        catch (exc) {
            this.setState({ backupToDelete: null, showDeleteConfirmationModal: false, showErrorModal: true, errorModalText: "An error occurred: " + exc });
        }
        e.preventDefault();
    }
    
    timestampToString = (t) => {
        const d = new Date(t);
        return d.toUTCString();
    }

    mapBackupToListItem = (backup) => {
        const backupDate = this.timestampToString(backup.timestamp);
        return (
            <>
                <ListGroup.Item style={{ overflow: "hidden" }} key={backup.fileName}>
                    <Row noGutters className="my-auto">
                        <Col xs="auto" md="auto">
                            <Button variant="link" onClick={(e) => this.askDeleteBackup(e, backup)}><FaTrash color="red"/></Button>
                        </Col>
                        <Col className="my-auto text-left" as="h5">
                            {backupDate}
                        </Col>
                    </Row>
                </ListGroup.Item>
                <Modal show={this.state.showDeleteConfirmationModal} onHide={() => this.setState({ showDeleteConfirmationModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Delete Backup</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>Delete backup '{this.state.showDeleteConfirmationBackupName}'?</Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={() => this.setState({ showDeleteConfirmationModal: false })}>
                            Cancel
                        </Button>
                        <Button variant="danger" onClick={(e) => this.doDeleteBackup(e)}>
                            Delete
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }

    renderBackupsList() {
        return (
            <ListGroup>
                {this.state.backups.map(this.mapBackupToListItem)}
            </ListGroup>
        );
    }

    render() {
        return (
            <>
                <Container fluid>
                    <Row><Col><h3 className="text-center">Backups</h3></Col></Row>
                    <br/>
                    <Row><Col><Button variant="outline-primary" block onClick={(e) => this.createBackup(e)}><FaPlus/></Button></Col></Row>
                    <br/>
                    {this.renderBackupsList()}
                </Container>
                <Modal show={this.state.showErrorModal} onHide={() => this.setState({ showErrorModal: false })}>
                    <Modal.Header closeButton>
                        <Modal.Title>Error</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>{this.state.errorModalText}</Modal.Body>
                    <Modal.Footer>
                        <Button onClick={() => this.setState({ showErrorModal: false })}>
                            OK
                        </Button>
                    </Modal.Footer>
                </Modal>
            </>
        );
    }
}